import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils";
const strengthColors = [
    "bg-red-500",
    "bg-amber-700",
    "bg-green-600",
    "bg-black",
];
const getActiveBars = (metCount, total) => {
    if (metCount >= total)
        return 4;
    if (metCount >= 6)
        return 3;
    if (metCount >= 4)
        return 2;
    if (metCount >= 2)
        return 1;
    return 0;
};
export const PasswordStrengthMeter = ({ metCount, total, className }) => {
    const activeBars = getActiveBars(metCount, total);
    return (_jsx("div", { className: cn("flex gap-1", className), "data-testid": "password-strength-meter", children: [0, 1, 2, 3].map((idx) => (_jsx("div", { className: cn("flex-1 transition-all duration-300", idx < activeBars ? strengthColors[idx] : "bg-gray-200"), style: { height: "4px", borderRadius: "32px" } }, idx))) }));
};
//# sourceMappingURL=PasswordStrengthMeter.js.map